import {RestServiceImpl} from "../rest.service.impl";
import {RestService} from "../rest.service.interface";
import {Component, Inject} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {AuthService} from "../../../shared/auth.service";
// import {DragulaService} from "ng2-dragula";
import {LoggerService} from "../../../shared/logger.service";
import {oase_config} from "../../../../environments/environment";
import {DateiArtDetails} from "../../datei/dateiartdetails.model";
import {Datei} from "../../datei/datei.model";
import {HttpClient} from "@angular/common/http";
import {APIConfigService} from "../../../api.config.service";
import {Observable} from "rxjs";
import {Kernantwort} from "../../../shared/response/kernantwort.model";
import {Httpstatus} from "../../../shared/response/httpstatus.model";
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';
import {DateiArt} from "../../datei/dateiart.model";
import {Sprache} from "../../sprache/sprache.model";
import {SpracheBase} from "../../sprache/sprache.base.model";
import {MaterialDesignIcons} from "../../../shared/materialdesignicons.model";
import {AngularMaterial2Module} from "../../../app.module.material";
import {FormsModule} from "@angular/forms";
import {FlexModule} from "@ngbracket/ngx-layout";

const PATH_FILE = 'app/protected/firma/images.select.component.ts';

// const REST_API_BASE =
//   ( window.location.hostname == 'localhost' ? oase_config.restapi.schema + '://' : '' ) + // z.B. http://
//   ( window.location.hostname == 'localhost' ? oase_config.restapi.host : '' ) + // z.B. masterproject.oase.at
//   ( window.location.hostname == 'localhost' ? ( oase_config.restapi.port ? ':' + oase_config.restapi.port : '' ) : '' ) + '/' + // z.B. :80/ oder /
//   oase_config.restapi.path + '/'; // z.B. masterproject/
//
// const REST_API_DATEI = REST_API_BASE + 'datei/';

@Component({
    selector: 'oase-icons-select.dialog',
    templateUrl: './icons.select.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true, imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule, FlexModule]

})
export class IconsSelectComponent {

    seconddialogrunningajaxcall = false;
    aktuellicons: string[] = Array<string>();
    fehlerMain: Kernantwort = null;
    public aktuell = null;
    OBJ_LNG_NAME = null;

    constructor(public dialogRef: MatDialogRef<IconsSelectComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dataService: RestService,
        public authService: AuthService,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
        public _logger: LoggerService)
    {

        this.aktuell = data.aktuell;
        this.OBJ_LNG_NAME = data.OBJ_LNG_NAME;
        this.aktuellicons = MaterialDesignIcons.list;

    }

    setzeFehler(fehler: Kernantwort) {
        this.fehlerMain = fehler;
    }

    iconAuswaehlen(icon: string) {
        this._logger.log(PATH_FILE + ' - iconAuswaehlen BEGIN');
        this._logger.log(PATH_FILE + ' - iconAuswaehlen this.aktuell: ', this.aktuell);
        this._logger.log(PATH_FILE + ' - iconAuswaehlen icon: ', icon);

        if(icon !== null)
          this.aktuell.icon = icon;
        this.dialogRef.close(false);

    } // iconAuswaehlen

}
